import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { TranslationService } from 'lib-base';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule, RouterOutlet,
    ToastModule
  ],
  providers: [],
  template: `
    <p-toast [baseZIndex]="2000" [autoZIndex]="true"></p-toast>
    <router-outlet></router-outlet>
  `,
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'tramitantes';

  constructor(private translate: TranslationService) { }
}
